import { KeyboardEvent } from "react";
import { FormControl, RadioGroup, Stack } from "@mui/material";
import { useTranslation } from "next-i18next";
import { EnumLeverageProductsIndication } from "src/api/client/extended-search.api.types";
import { handleLeverageProducts } from "src/components/pages/search/store/actions";
import { useSearchStore } from "src/components/pages/search/store/search-store";
import { KEY_ENTER, KEY_SPACE } from "src/constants/keyboard";
import { RadioWithLabel } from "src/theme-mui/components/radio/radio-with-label";

export const LeverageProductsSelection = () => {
    const { t } = useTranslation("extended-search");

    const options = [
        { label: t("all-wikifolios"), value: String(EnumLeverageProductsIndication.AllWikifolios) },
        { label: t("with-leverage-products"), value: String(EnumLeverageProductsIndication.WikifoliosWithLeverageProducts) },
        { label: t("without-leverage-products"), value: String(EnumLeverageProductsIndication.WikifoliosWithoutLeverageProducts) },
    ];

    const { leverageProductsIndication } = useSearchStore();

    const handleChange = (newIndication: string) => {
        handleLeverageProducts({
            leverageProductsIndication: Number(newIndication),
        });
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLLabelElement>, newIndication: string) => {
        if (event.key === KEY_SPACE || event.key === KEY_ENTER) {
            event.preventDefault();
            handleChange(newIndication);
        }
    };

    return (
        <FormControl>
            <RadioGroup
                onChange={event => {
                    handleChange(event.target.value);
                }}
                value={String(leverageProductsIndication)}
            >
                <Stack direction={{ xs: "column", sm: "row" }} spacing={3}>
                    {options.map(opt => (
                        <RadioWithLabel onKeyDown={event => handleKeyDown(event, opt.value)} key={opt.value} value={opt.value} label={opt.label} />
                    ))}
                </Stack>
            </RadioGroup>
        </FormControl>
    );
};
